
import { computed } from '@nuxtjs/composition-api';



export default {
  props: {
    productInformation: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const NUMS_PER_GROUP = 2
    const chunckedItems = computed(() => props.productInformation.map((_, i) => props.productInformation.slice(i * NUMS_PER_GROUP, (i + 1) * NUMS_PER_GROUP)));

    return {
      chunckedItems
    }
  }
}
